<template>
    <div class="row">
        <div class="col-10">
            
            <div class="card card-info mb-2">
                <div class="card-header">
                    <h4 class="card-title float-start">{{paziente.cognome}} {{paziente.nome}}</h4>
                </div>
                <div class="m-2">
                    <div class="row" align="left">
                        <div class="col-2">
                            <p><strong>Pratica:</strong></p>
                        </div>
                        <div class="col-10">
                            <p>{{pratica.nome}}</p>
                        </div>
                    </div>
                    <div class="row" align="left">
                        <div class="col-2">
                            <p><strong>Data Inizio:</strong></p>
                        </div>
                        <div class="col-10">
                            <p>{{pratica.data_inizio}}</p>
                        </div>
                    </div>
                    <div class="row" align="left">
                        <div class="col-2">
                            <p><strong>Data Fine:</strong></p>
                        </div>
                        <div class="col-10">
                           <p>{{pratica.data_fine}}</p>
                        </div>
                    </div>
                    <div class="row" align="left">
                        <div class="col-2">
                            <p><strong>Giorni Settimana:</strong></p>
                        </div>
                        <div class="col-10">
                           <ul class="list-group">
                                <li class="list-group-item" v-for="giorno in pratica.giorni_settimana">{{giorno.nome_giorno}}</li>
                            </ul>
                        </div>
                    </div>   
                    
                </div>

                
                        
            </div>
        </div>
        <div class="col-2">
            <div class="card card-info mb-2">
                    <a :href="route('pazienti.stato_pratica', [pratica.id,0])" class="btn btn-outline-danger m-2" v-if="pratica.data_fine == null">Fine Pratica</a>
                    <a :href="route('pazienti.stato_pratica', [pratica.id,1])" class="btn btn-outline-success m-2" v-else>Riattiva Pratica</a>
                    
                
            </div> 
        </div>
    </div>
    <div class="card card-info mb-2">
        <div class="card-header">
            <h4 class="card-title float-start">Esercizi {{pratica.nome}}</h4>
        </div>

        <table class="table table-striped" v-if="pratica_esercizi.length > 0">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Nome</th>
                    <th scope="col">Descrizione</th>
                    <th scope="col">Obiettivo</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="esercizio in pratica_esercizi" :key="esercizio.id">
                    <th scope="row">{{ esercizio.id }}</th>
                    <td>{{ esercizio.nome }}</td>
                    <td>{{ esercizio.descrizione }}</td>
                    <td>{{ esercizio.obiettivo }}</td>
                </tr>
            </tbody>
        </table>
                
    </div>

    <div class="card card-info">
        <div class="card-header">
            <h4 class="card-title float-start">Aggiungi Esercizio a {{pratica.nome}}</h4>
        </div>
        <form @submit.prevent="submit">
            <div class="row m-2" align="left">
                <div class="col-12">
                    <div class="input-group">
                        <select class="form-select" aria-label="esercizi" @change="onChange($event)">
                            <option value="no">
                                Seleziona un template di partenza :)
                            </option>
                            <option v-for="item in esercizi" :value="item.id" :key="item.id">
                                {{ item.nome }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-md-12 text-start">
                    <label for="nome" class="form-label">Nome:</label>
                    <div class="input-group has-validation">
                        <input type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form.nome" autofocus aria-describedby="nomeFeedback" required>
                        <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                            {{errors.nome}}
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-start">
                    <label for="descrizione" class="form-label">Descrizione:</label>
                    <div class="input-group has-validation">
                        <textarea type="text" :class="{'form-control':true, 'is-invalid':errors.descrizione ? true : false}" id="descrizione" v-model="form.descrizione" autofocus aria-describedby="descrizioneFeedback" row="5" required></textarea>
                        <div v-if="errors.descrizione" id="descrizioneFeedback" class="invalid-feedback">
                            {{errors.descrizione}}
                        </div>
                    </div>
                </div>

                <div class="col-md-12 text-start">
                    <label for="obiettivo" class="form-label">Obiettivo:</label>
                    <div class="input-group has-validation">
                        <textarea type="text" :class="{'form-control':true, 'is-invalid':errors.obiettivo ? true : false}" id="obiettivo" v-model="form.obiettivo" autofocus aria-describedby="obiettivoFeedback"  row="5" ></textarea>
                        <div v-if="errors.obiettivo" id="obiettivoFeedback" class="invalid-feedback">
                            {{errors.obiettivo}}
                        </div>
                    </div>
                </div> 

                <div class="col-md-12 text-start">
                    <label for="minuti" class="form-label">Minuti Esecuzione:</label>
                    <div class="input-group has-validation">
                        <input type="number" :class="{'form-control':true, 'is-invalid':errors.minuti ? true : false}" id="minuti" v-model="form.minuti" autofocus aria-describedby="minutiFeedback">
                        <div v-if="errors.minuti" id="minutiFeedback" class="invalid-feedback">
                            {{errors.minuti}}
                        </div>
                    </div>
                </div> 
            </div>

            <div class="modal-footer">
                <button type="submit" class="btn btn-primary m-2" :disabled="form.processing">
                    Aggiungi Esercizio
                </button>
            </div>        
        </form>


                
    </div>




        
</template>
<script>
import Main from "@/Layouts/Main.vue";
import ShowButton from "@/Components/ShowButton.vue";
import EditButton from "@/Components/EditButton.vue";
import DeleteButton from "@/Components/DeleteButton.vue";
import ConfirmBox from "@/Components/ConfirmBox.vue";
import Pagination from "@/Components/Pagination.vue";

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        paziente: Object,
        pratica: Object,
        esercizi: Array,
        pratica_esercizi: Array,
        flash: Object,
    },
    components: {
        ShowButton,
        EditButton,
        DeleteButton,
        ConfirmBox,
        Pagination,
    },
    data() {
        return {
            isOpen: false,
            form: this.$inertia.form({
                pratica_id: this.pratica.id,
                esercizio_id: -1,
                nome: "" ,
                descrizione:  "" ,
                obiettivo:  "",
                minuti:  "",
            })
        };
    },
    methods: {
        modalStatus(status) {
            this.isOpen = status;
        },

        onChange(event) {
            console.log(JSON.stringify(event.target.value));
            var esercizio = this.esercizi.find(esercizio => esercizio.id == event.target.value);
            this.form.esercizio_id = event.target.value;
            this.form.nome = esercizio.nome;
            this.form.descrizione = esercizio.descrizione;
            this.form.obiettivo = esercizio.obiettivo;
            this.form.minuti = esercizio.minuti;
        },


        submit() {
            let route = this.route("pazienti.aggiungi_pratica_esercizio")
            let method = 'post'
            this.form['post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        
                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                        if (errors.hasOwnProperty("descrizione")) {
                            toast.message = errors.descrizione;
                            this.errors.descrizione = errors.descrizione;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },

        
    },

    computed: {
        
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);

        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
    updated() {
        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
};
</script>
